module.exports = __webpack_public_path__ + "img/NW12.810db934.gif";